var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Helpers, doKey2ClickUp, SurveyModel, doKey2ClickBlur, doKey2ClickDown, SvgRegistry, addIconsToThemeSet } from "survey-core";
import { SurveyElementBase } from "./reactquestion_element";
import { SurveyHeader } from "./components/survey-header/survey-header";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { ReactElementFactory } from "./element-factory";
import { BrandInfo } from "./components/brand-info";
import { NotifierComponent } from "./components/notifier";
import { ComponentsContainer } from "./components/components-container";
import { SvgBundleComponent } from "./svgbundle";
import { PopupModal } from "./components/popup/popup-modal";
import { icons as iconsV1 } from "survey-core/icons/iconsV1";
import { icons as iconsV2 } from "survey-core/icons/iconsV2";
import { Scroll } from "./components/scroll";
addIconsToThemeSet("v1", iconsV1);
addIconsToThemeSet("v2", iconsV2);
SvgRegistry.registerIcons(iconsV2);
var Survey = /** @class */ (function (_super) {
    __extends(Survey, _super);
    function Survey(props) {
        var _this = _super.call(this, props) || this;
        _this.previousJSON = {};
        _this.isSurveyUpdated = false;
        _this.createSurvey(props);
        _this.updateSurvey(props, {});
        _this.rootRef = React.createRef();
        _this.rootNodeId = props.id || null;
        _this.rootNodeClassName = props.className || "";
        return _this;
    }
    Survey.prototype.getStateElement = function () {
        return this.survey;
    };
    Survey.prototype.onSurveyUpdated = function () {
        if (!!this.survey) {
            var el = this.rootRef.current;
            if (!!el)
                this.survey.afterRenderSurvey(el);
            this.survey.startTimerFromUI();
            this.setSurveyEvents();
        }
    };
    Survey.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (!_super.prototype.shouldComponentUpdate.call(this, nextProps, nextState))
            return false;
        if (this.isModelJSONChanged(nextProps)) {
            this.destroySurvey();
            this.createSurvey(nextProps);
            this.updateSurvey(nextProps, {});
            this.isSurveyUpdated = true;
        }
        return true;
    };
    Survey.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.updateSurvey(this.props, prevProps);
        if (this.isSurveyUpdated) {
            this.onSurveyUpdated();
            this.isSurveyUpdated = false;
        }
    };
    Survey.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.onSurveyUpdated();
    };
    Survey.prototype.destroySurvey = function () {
        if (this.survey) {
            this.survey.renderCallback = undefined;
            this.survey.onPartialSend.clear();
            this.survey.stopTimer();
            this.survey.destroyResizeObserver();
        }
    };
    Survey.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.destroySurvey();
    };
    Survey.prototype.doRender = function () {
        var renderResult;
        if (this.survey.state == "completed") {
            renderResult = this.renderCompleted();
        }
        else if (this.survey.state == "completedbefore") {
            renderResult = this.renderCompletedBefore();
        }
        else if (this.survey.state == "loading") {
            renderResult = this.renderLoading();
        }
        else if (this.survey.state == "empty") {
            renderResult = this.renderEmptySurvey();
        }
        else {
            renderResult = this.renderSurvey();
        }
        var backgroundImage = !!this.survey.backgroundImage ? React.createElement("div", { className: this.css.rootBackgroundImage, style: this.survey.backgroundImageStyle }) : null;
        var header = this.survey.headerView === "basic" ? React.createElement(SurveyHeader, { survey: this.survey }) : null;
        var onSubmit = function (event) {
            event.preventDefault();
        };
        var customHeader = React.createElement("div", { className: "sv_custom_header" });
        if (this.survey.hasLogo) {
            customHeader = null;
        }
        var rootCss = this.survey.getRootCss();
        var cssClasses = this.rootNodeClassName ? this.rootNodeClassName + " " + rootCss : rootCss;
        return (React.createElement("div", { id: this.rootNodeId, ref: this.rootRef, className: cssClasses, style: this.survey.themeVariables, lang: this.survey.locale || "en", dir: this.survey.localeDir },
            React.createElement(Scroll, { disabled: this.survey.rootScrollDisabled },
                this.survey.needRenderIcons ? React.createElement(SvgBundleComponent, null) : null,
                React.createElement(PopupModal, null),
                React.createElement("div", { className: this.survey.wrapperFormCss },
                    backgroundImage,
                    React.createElement("form", { onSubmit: onSubmit },
                        React.createElement(Scroll, { disabled: this.survey.formScrollDisabled },
                            customHeader,
                            React.createElement("div", { className: this.css.container },
                                header,
                                React.createElement(ComponentsContainer, { survey: this.survey, container: "header", needRenderWrapper: false }),
                                renderResult,
                                React.createElement(ComponentsContainer, { survey: this.survey, container: "footer", needRenderWrapper: false })))),
                    React.createElement(NotifierComponent, { notifier: this.survey.notifier })))));
    };
    Survey.prototype.renderElement = function () {
        return this.doRender();
    };
    Object.defineProperty(Survey.prototype, "css", {
        get: function () {
            return this.survey.css;
        },
        set: function (value) {
            this.survey.css = value;
        },
        enumerable: false,
        configurable: true
    });
    Survey.prototype.renderCompleted = function () {
        if (!this.survey.showCompletedPage)
            return null;
        var htmlValue = { __html: this.survey.processedCompletedHtml };
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { dangerouslySetInnerHTML: htmlValue, className: this.survey.completedCss }),
            React.createElement(ComponentsContainer, { survey: this.survey, container: "completePage", needRenderWrapper: false })));
    };
    Survey.prototype.renderCompletedBefore = function () {
        var htmlValue = { __html: this.survey.processedCompletedBeforeHtml };
        return (React.createElement("div", { dangerouslySetInnerHTML: htmlValue, className: this.survey.completedBeforeCss }));
    };
    Survey.prototype.renderLoading = function () {
        var htmlValue = { __html: this.survey.processedLoadingHtml };
        return (React.createElement("div", { dangerouslySetInnerHTML: htmlValue, className: this.survey.loadingBodyCss }));
    };
    Survey.prototype.renderSurvey = function () {
        var activePage = this.survey.activePage
            ? this.renderPage(this.survey.activePage)
            : null;
        var isStaring = this.survey.isShowStartingPage;
        var pageId = this.survey.activePage ? this.survey.activePage.id : "";
        var className = this.survey.bodyCss;
        var style = {};
        if (!!this.survey.renderedWidth) {
            style.maxWidth = this.survey.renderedWidth;
        }
        return (React.createElement("div", { className: this.survey.bodyContainerCss },
            React.createElement(ComponentsContainer, { survey: this.survey, container: "left" }),
            React.createElement("div", { className: "sv-components-column sv-components-column--expandable" },
                React.createElement(ComponentsContainer, { survey: this.survey, container: "center" }),
                React.createElement("div", { id: pageId, className: className, style: style },
                    React.createElement(ComponentsContainer, { survey: this.survey, container: "contentTop" }),
                    activePage,
                    React.createElement(ComponentsContainer, { survey: this.survey, container: "contentBottom" }),
                    this.survey.showBrandInfo ? React.createElement(BrandInfo, null) : null)),
            React.createElement(ComponentsContainer, { survey: this.survey, container: "right" })));
    };
    Survey.prototype.renderPage = function (page) {
        return ReactElementFactory.Instance.createElement(this.survey.pageComponent || "sv-page", {
            survey: this.survey,
            page: page,
            css: this.css,
            creator: this,
        });
    };
    Survey.prototype.renderEmptySurvey = function () {
        return React.createElement("div", { className: this.css.bodyEmpty }, this.survey.emptySurveyText);
    };
    Survey.prototype.createSurvey = function (newProps) {
        if (!newProps)
            newProps = {};
        this.previousJSON = {};
        if (newProps) {
            if (newProps.model) {
                this.survey = newProps.model;
            }
            else {
                if (newProps.json) {
                    this.previousJSON = newProps.json;
                    this.survey = new SurveyModel(newProps.json);
                }
            }
        }
        else {
            this.survey = new SurveyModel();
        }
        if (!!newProps.css) {
            this.survey.css = this.css;
        }
    };
    Survey.prototype.isModelJSONChanged = function (newProps) {
        if (!!newProps["model"]) {
            return this.survey !== newProps["model"];
        }
        if (!!newProps["json"]) {
            return !Helpers.isTwoValueEquals(newProps["json"], this.previousJSON);
        }
        return false;
    };
    Survey.prototype.updateSurvey = function (newProps, oldProps) {
        if (!newProps)
            return;
        oldProps = oldProps || {};
        for (var key in newProps) {
            if (key == "model" || key == "children" || key == "json") {
                continue;
            }
            if (key == "css") {
                this.survey.mergeValues(newProps.css, this.survey.getCss());
                this.survey["updateNavigationCss"]();
                this.survey["updateElementCss"]();
                continue;
            }
            if (newProps[key] === oldProps[key])
                continue;
            if (key.indexOf("on") == 0 && this.survey[key] && this.survey[key].add) {
                if (!!oldProps[key]) {
                    this.survey[key].remove(oldProps[key]);
                }
                this.survey[key].add(newProps[key]);
            }
            else {
                this.survey[key] = newProps[key];
            }
        }
    };
    Survey.prototype.setSurveyEvents = function () {
        var self = this;
        this.survey.renderCallback = function () {
            var counter = !!self.state && !!self.state.modelChanged ? self.state.modelChanged : 0;
            self.setState({ modelChanged: counter + 1 });
        };
        this.survey.onPartialSend.add(function (sender) {
            if (!!self.state) {
                self.setState(self.state);
            }
        });
    };
    //ISurveyCreator
    Survey.prototype.createQuestionElement = function (question) {
        return ReactQuestionFactory.Instance.createQuestion(question.isDefaultRendering() ? question.getTemplate() : question.getComponentName(), {
            question: question,
            isDisplayMode: question.isInputReadOnly,
            creator: this,
        });
    };
    Survey.prototype.renderError = function (key, error, cssClasses, element) {
        return ReactElementFactory.Instance.createElement(this.survey.questionErrorComponent, { key: key, error: error, cssClasses: cssClasses, element: element });
    };
    Survey.prototype.questionTitleLocation = function () {
        return this.survey.questionTitleLocation;
    };
    Survey.prototype.questionErrorLocation = function () {
        return this.survey.questionErrorLocation;
    };
    return Survey;
}(SurveyElementBase));
export { Survey };
ReactElementFactory.Instance.registerElement("survey", function (props) {
    return React.createElement(Survey, props);
});
export function attachKey2click(element, viewModel, options) {
    if (options === void 0) { options = { processEsc: true, disableTabStop: false }; }
    var props = {};
    if ((!!viewModel && viewModel.disableTabStop) || (!!options && options.disableTabStop)) {
        props = { tabIndex: -1 };
    }
    else {
        options = __assign({}, options);
        props = {
            tabIndex: 0,
            onKeyUp: function (evt) {
                evt.preventDefault();
                evt.stopPropagation();
                doKey2ClickUp(evt, options);
            },
            onKeyDown: function (evt) { return doKey2ClickDown(evt, options); },
            onBlur: function (evt) { return doKey2ClickBlur(evt); },
        };
    }
    props["onPointerUp"] = function (evt) {
        if (evt.pointerType === "pen") {
            evt.preventDefault();
            evt.stopPropagation();
            var element_1 = evt.target;
            if (element_1 === null || element_1 === void 0 ? void 0 : element_1.click)
                element_1.click();
        }
    };
    return React.cloneElement(element, props);
}
